import { onDocumentReady } from "@story/story_assets";
import { Carousel } from "@story/story_assets/carousel";

import "@story/story_assets/dom_extend";
import "@story/story_assets/ajax";
import "@story/story_assets/ajax_form";
import "@story/story_assets/recaptcha";
import "@story/story_assets/cookies";
import "@story/story_assets/module_loader";
import "@story/story_assets/modules/base";
import "@story/story_assets/modules/google_recaptcha";
import "@story/story_assets/snippets";

import "@story/story_assets/animations";
import "@story/story_assets/slide";

import "@story/story_assets/modal/modal";
import { ModalDialog } from "@story/story_assets/modal/modal_dialog";
import "@story/story_assets/modal/modal_gallery";

import "./components/images";
import "./components/remote_links";

document.addEventListener("open-ajax-modal", function(event) {
	var url = event.detail && event.detail.url;
	if (url) {
		ModalDialog.openAjax(url);
	}
});

; (function() {

	//
	// Carousels
	//
	onDocumentReady(function() {
		var carousels = document.querySelectorAll(".carousel");
		for (var i = 0; i < carousels.length; ++i) {
			new Carousel(carousels[i]);
		}

		// var sliders = document.querySelectorAll(".snap-slider");
		// for (var i = 0; i < sliders.length; ++i) {
		// 	Slider.get(sliders[i]);
		// }
	});

	//
	// Homepage banner links
	//
	onDocumentReady(function() {
		document.addEventListener("click", function(event) {
			var slide = event.target.closest(".homepage-carousel-slide[data-link-url]");
			if (slide && !event.target.closest(".homepage-carousel-dot")) {
				var linkUrl = slide.getAttribute("data-link-url");
				if (linkUrl) {
					window.location.href = linkUrl;
				}
			}
		});
	});

}());
